import React from "react";
import { VMBuilder } from "../../../../commons/base/providers/builder";
import Select from "react-select";
import WasteAdjustmentViewModel from "../view_models/waste_adjustment_view_model";

export default class WasteAdjustmentFilterWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<WasteAdjustmentViewModel>>
                {(vm) => (
                    <div className="flex flex-wrap items-center mb-5 space-y-3 md:space-y-0">
                        <div className="relative mr-2">
                            <Select
                                options={vm.locations.map((option) => ({
                                    value: option.id,
                                    label: option.name,
                                }))}
                                placeholder={"Pilih Lokasi Waste"}
                                isClearable={true}
                                isSearchable={true}
                                onChange={(option) => {
                                    if (option?.value) {
                                        vm.fetchWasteList(option?.value);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
